<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;" width="300">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<!-- <v-col cols="12">
								<v-menu
									v-model="menu.datebegin"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.datebegin"
										label="Дата початку періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.datebegin"
									@input="menu.datebegin = false"
									></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12">
								<v-menu
									v-model="menu.dateend"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.dateend"
										label="Дата завершення періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.dateend"
									@input="menu.dateend = false"
									></v-date-picker>
								</v-menu>
							</v-col> -->
							<v-col cols="12">
								<v-combobox
									v-model="params.region"
									:items="regions"
									label="Область"
									outlined
									dense
									item-text="name"
									item-value="code"
									hide-details="auto"
									clearable
									:loading="loading.region"
									@change="onRegion"
									@focus="loadRegion"
								>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.kind"
									:items="kinds"
									label="Категорія"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.kind"
									@change="onKind"
									@focus="loadKind"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.brand"
									:items="brands"
									label="Марка"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.brand"
									@change="onBrand"
									@focus="loadBrand"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.model"
									:items="models"
									label="Модель"
									item-text="name"
									item-value="id"
									outlined
									dense
									hide-details="auto"
									clearable
									:loading="loading.model"
									@change="onModel"
									@focus="loadModel"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-system-bar>
									<span>Рік випуску авто</span>
									<v-spacer></v-spacer>
								</v-system-bar>
							</v-col>
							<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
								<v-combobox
									v-model="params.makeYearFrom"
									:items="years"
									label="Від"
									item-text="name"
									item-value="id"
									:return-object="false"
									outlined
									dense
									hide-details="auto"
									clearable
									:loading="loading.year"
									@change="onYear"
									@focus="loadYear"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
								<v-combobox
									v-model="params.makeYearTo"
									:items="years"
									label="До"
									item-text="name"
									item-value="id"
									:return-object="false"
									outlined
									dense
									hide-details="auto"
									clearable
									:loading="loading.year"
									@change="onYear"
									@focus="loadYear"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.body"
									:items="bodies"
									label="Тип кузова"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.body"
									@focus="loadBodies"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.fuel"
									:items="fuels"
									label="Тип пального"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.fuel"
									@focus="loadFuels"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.color"
									:items="colors"
									label="Колір"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.color"
									@focus="loadColors"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.person"
									:items="persons"
									label="Особа"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.person"
									@change="onPerson"
									@focus="loadPerson"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.purpose"
									:items="purposes"
									label="Спосіб використання"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.purpose"
									@focus="loadPurposes"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.operation"
									:items="operations"
									label="Тип реєстрації"
									outlined
									dense
									item-text="name"
									item-value="id"
									hide-details="auto"
									clearable
									:loading="loading.operation"
									@focus="loadOperations"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
									<template v-slot:no-data>
										<div class="text-center font-weight-thin">{{ noDataText }}</div>
									</template>
								</v-combobox>
							</v-col>
						</v-row>

						<!-- <v-divider class="my-6"></v-divider>

						<v-select
							v-model="selectedHeaders"
							:items="groupHeaders"
							attach
							chips
							label="Поля для групування"
							multiple
							return-object
						></v-select> -->
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right floating
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>
		
		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
		
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
					<v-spacer></v-spacer>
					<v-menu offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon v-bind="attrs" v-on="on">
								<v-icon>mdi-table-check</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item-group v-model="selectedHeaders" multiple return-object>
								<v-list-item v-for="(item, index) in groupHeaders" :key="index" :value="item">
									<template v-slot:default="{ active }">
										<v-list-item-action>
											<v-checkbox :input-value="active"></v-checkbox>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>{{ item.text }}</v-list-item-title>
										</v-list-item-content>
									</template>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
					<!-- <v-btn icon @click="onTest">
						<v-icon>mdi-table-check</v-icon>
					</v-btn> -->
				</v-card-title>

				<v-divider></v-divider>

				<!-- <v-data-table v-if="data.datasets.ds.length" -->
				<v-data-table
					:headers="visibleHeaders"
					:items="items"
					hide-default-footer
					disable-pagination
					:loading="loading.table"
				>
					<template #item.percentage="{ item }">
						{{ calculatePercentage(item.cnt, total) }}
					</template>
				</v-data-table>
				<!-- :items="data.datasets.ds" -->
			</v-card>
		</v-container>
		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay> -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<!-- <z-pdf ref="pdf" :code="code" :name="name"></z-pdf> -->
	</v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'
// import downloadExcel from "vue-json-excel"

export default {
	mixins: [mixin],
	components: { },
	data: () => ({
		noDataText: 'Зачекайте...',
		selectedHeaders: [],
		headers: [
			{ text: 'Область', value: 'regionName' },
			{ text: 'Категорія', value: 'kindName' },
			{ text: 'Марка', value: 'brandName' },
			{ text: 'Модель', value: 'modelName' },
			{ text: 'Рік виробництва', value: 'makeYear' },
			{ text: 'Особа', value: 'personName' },
			{ text: 'Кількість', value: 'cnt' },
			{ text: '%', value: 'percentage', sortable: false },
		],

		regions: [],
		cities: [],
		kinds: [],
		brands: [],
		models: [],
		years: [],
		persons: [],
		operations: [],
		colors: [],
		bodies: [],
		fuels: [],
		purposes: [],
		
		loading: {
			region: false,
			city: false,
			kind: false,
			brand: false,
			model: false,
			year: false,
			person: false,
			operation: false,
			color: false,
			body: false,
			fuel: false,
			purpose: false,
			table: false,
		},
	}),

	props: {
		code: 				{ type: String, default: 'VehicleReestr' },
		name: 				{ type: String, default: 'Статистика на основі даних реєстру транспортних засобів' },
		datebegin: 			{ type: [Date, String] },
		dateend: 			{ type: [Date, String] },
	},

	computed: {
		...mapGetters('ReportVehicleReestr', [ 'items' ] ),

		total() {
			const total = this.items.reduce((sum, item) => sum + parseInt(item.cnt), 0);
			return total
		},

		visibleHeaders() {
			return this.headers.filter(header => 
				this.selectedHeaders.find(s => s.value === header.value)
			);
		},

		groupHeaders () {
			return this.headers.filter(item => ['regionName','kindName','brandName','modelName','makeYear','personName'].includes(item.value));
		}
	},

	created() {
		this.selectedHeaders = [...this.headers];
	},

	methods: {
		...mapActions('ReportVehicleReestr', [ 'setItems' ]),

		getParams() {
			return {
				regionCode: this.params?.region?.code
				,kindName: this.params?.kind?.id
				,brandName: this.params?.brand?.id
				,modelName: this.params?.model?.id
				,person: this.params?.person?.id
				,makeYearFrom: this.params.makeYearFrom
				,makeYearTo: this.params.makeYearTo
				,operCode: this.params?.operation?.id
				,colorName: this.params?.color?.id
				,bodyName: this.params?.body?.id
				,fuelName: this.params?.fuel?.id
				,purpose: this.params?.purpose?.id
			}
		},
		
		//-------------------------------------------------

		clearRegion () {
			/* this.params.region = null
			this.regions = []
			this.clearCity() */
		},

		onRegion (item) {
			/* this.clearCity()
			this.clearKind() */
			//this.params.kind = null
			//this.loadKind()
		},

		loadRegion(e) {
			this.loading.region = true
			this.regions = []
			var that = this
			axios.get('/koatuu/regions').then(response => {
				that.regions = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.region = false));
		},

		//-------------------------------------------------
		clearCity () {
			/* this.params.city = null
			this.cities = []
			this.clearKind() */
		},

		onCity (item) {
			/* this.clearModel() */
		},

		loadCity(e) {
			//console.log('loadCity', this.params)
			if(this.params?.region?.id) {
				this.loading.city = true
				var that = this
				axios.get(`/koatuu/region/${this.params.region.code}/cities`).then(response => {
					that.cities = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.city = false));
			}
		},

		//-------------------------------------------------
		clearKind () {
			/* this.kinds = []
			this.params.kind = null
			this.clearBrand() */
			//this.clearYear()
		},

		onKind (item) {
			/* this.params.brand = null
			this.params.makeYearFrom = null
			this.params.makeYearTo = null
			this.loadBrand() */
		},

		loadKind(e) {
			let that = this
			//console.log('loadKind', this.params)
			this.loading.kind = true
			this.kinds = []
			axios.get('/vehicle/reestr/kinds', { 
				params: {
					regionCode: this.params?.region?.code
					//,kindName: this.params?.kind?.id
					//,brandName: this.params?.brand?.id
					//,modelName: this.params?.model?.id
					//,person: this.params?.person?.id
					//,makeYearFrom: this.params.makeYearFrom
					//,makeYearTo: this.params.makeYearTo
				}
			}).then(response => {
				that.kinds = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.kind = false));
		},

		//-------------------------------------------------
		clearBrand () {
			/* this.brands = []
			this.params.brand = null
			this.clearPerson() */
		},

		onBrand (item) {
			/* this.clearPerson() */
		},

		loadBrand(e) {
			let that = this
			//console.log('loadBrand', this.params)
			this.loading.brand = true
			this.brands = []
			axios.get('/vehicle/reestr/brends', { 
				params: { 
					regionCode: this.params?.region?.code
					,kindName: this.params?.kind?.id
					//,brandName: this.params?.brand?.id
					//,modelName: this.params?.model?.id
					//,person: this.params?.person?.id
					//,makeYearFrom: this.params.makeYearFrom
					//,makeYearTo: this.params.makeYearTo
				}
			}).then(response => {
				that.brands = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.brand = false));
		},

		//-------------------------------------------------
		clearModel () {
			/* this.models = []
			this.clearYear() */
		},

		onModel (item) {
			/* this.params.yearbegin = null
			this.params.yearend = null
			this.loadYear() */
		},

		loadModel(e) {
			let that = this
			this.loading.model = true
			this.models = []
			axios.get('/vehicle/reestr/models', { 
				params: { 
					regionCode: this.params?.region?.code
					,kindName: this.params?.kind?.id
					,brandName: this.params?.brand?.id
					//,modelName: this.params?.model?.id
					//,person: this.params?.person?.id
					//,makeYearFrom: this.params.makeYearFrom
					//,makeYearTo: this.params.makeYearTo
				}
			}).then(response => {
				that.models = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.model = false));
		},

		//-------------------------------------------------
		clearYear () {
			/* this.years = []
			this.params.makeYearFrom = null
			this.params.makeYearTo = null */
		},
		/* clearYears () {
			this.years = []
			this.params.makeYearFrom = null
			this.params.makeYearTo = null
		}, */

		onYear (item) {
			//this.$set(this.params, 'model', null)
			//this.loadBrand()
		},

		loadYear(e) {
			let that = this
			//console.log('loadYear', this.params)
			this.loading.year = true
			axios.get('/vehicle/reestr/years', { 
				params: { 
					regionCode: this.params?.region?.code
					,kindName: this.params?.kind?.id
					,brandName: this.params?.brand?.id
					,modelName: this.params?.model?.id
					//,person: this.params?.person?.id
					//,makeYearFrom: this.params.makeYearFrom
					//,makeYearTo: this.params.makeYearTo
				}
			}).then(response => {
				//console.log(that.$options.name, 'loadYear','response.data', response.data)
				that.years = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.year = false));
		},

		//-------------------------------------------------
		clearPerson () {
			/* this.persons = []
			this.params.person = null
			this.clearYear() */
		},

		onPerson (item) {
			/* this.clearYear() */
		},

		loadPerson(e) {
			let that = this
			//console.log('loadYear', this.params)
			this.loading.person = true
			this.persons = []
			axios.get('/vehicle/reestr/persons', { 
				params: { 
					regionCode: this.params?.region?.code
					,kindName: this.params?.kind?.id
					,brandName: this.params?.brand?.id
					,modelName: this.params?.model?.id
					//,person: this.params?.person?.id
					,makeYearFrom: this.params.makeYearFrom
					,makeYearTo: this.params.makeYearTo
				}
			}).then(response => {
				//console.log(that.$options.name, 'loadYear','response.data', response.data)
				that.persons = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.person = false));
		},


		loadOperations(e) {
			let that = this
			this.loading.operation = true
			this.operations = []
			axios.get('/vehicle/reestr/operations', { params: this.getParams() }).then(response => {
				//console.log(that.$options.name, 'loadOperations','response.data', response.data)
				that.operations = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.operation = false));
		},

		loadColors(e) {
			let that = this
			this.loading.color = true
			this.colors = []
			axios.get('/vehicle/reestr/colors', { params: this.getParams() }).then(response => {
				//console.log(that.$options.name, 'loadColors','response.data', response.data)
				that.colors = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.color = false));
		},

		loadBodies(e) {
			let that = this
			this.loading.body = true
			this.bodies = []
			axios.get('/vehicle/reestr/bodies', { params: this.getParams() }).then(response => {
				//console.log(that.$options.name, 'loadBodies','response.data', response.data)
				that.bodies = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.body = false));
		},

		loadFuels(e) {
			let that = this
			this.loading.fuel = true
			this.fuels = []
			axios.get('/vehicle/reestr/fuels', { params: this.getParams() }).then(response => {
				//console.log(that.$options.name, 'loadFuels','response.data', response.data)
				that.fuels = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.fuel = false));
		},

		loadPurposes(e) {
			let that = this
			this.loading.purpose = true
			this.purposes = []
			axios.get('/vehicle/reestr/purposes', { params: this.getParams() }).then(response => {
				//console.log(that.$options.name, 'loadPurposes','response.data', response.data)
				that.purposes = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.purpose = false));
		},

		//-------------------------------------------------
		onOK() {
			let that = this
			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'params', this.params)
				const headers = this.selectedHeaders.map(item => item.value ).filter(item => item !== undefined);

				//console.log(this.$options.name, 'selectedHeaders', this.selectedHeaders)
				//console.log(this.$options.name, 'headers', headers)

				const params = { 
					//mode: this.params.mode,
					regionCode: this.params?.region?.code,
					kindName: this.params?.kind?.id,
					brandName: this.params?.brand?.id,
					modelName: this.params?.model?.id,
					person: this.params?.person?.id,
					makeYearFrom: this.params.makeYearFrom,
					makeYearTo: this.params.makeYearTo,
					headers: headers,
				}

				//console.log('onOK', 'params', params)

				this.loading.table = true
				//axios.post(`vehicle/reestr/statistic`, this.params).then(response => {
				axios.get('/vehicle/reestr/statistic', { params: params }).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItems(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading.table = false
				});
			}
		},

		calculatePercentage(value, total) {
			if (!total || total === 0) return 0;
			return ((value / total) * 100).toFixed(2); // Returns value with 2 decimals
		},

		onTest() {
			//console.log('onTest', 'visibleHeaders', this.visibleHeaders)
			console.log('onTest', 'selectedHeaders', this.selectedHeaders)
		},
	},
}
</script>